import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-24",
  style: {"text-align":"left","margin-top":"8px","margin-bottom":"8px"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "ant-row ss-grade-personalizada-titulo" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-4" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Produto")
  ]),
  /*#__PURE__*/_createElementVNode("div", {
    class: "ant-col ant-col-xs-24 ant-col-xl-2",
    style: {"text-align":"center"}
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Unidade")
  ]),
  /*#__PURE__*/_createElementVNode("div", {
    class: "ant-col ant-col-xs-24 ant-col-xl-3",
    style: {"text-align":"right"}
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Quantidade")
  ]),
  /*#__PURE__*/_createElementVNode("div", {
    class: "ant-col ant-col-xs-24 ant-col-xl-3",
    style: {"text-align":"right"}
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Peso")
  ]),
  /*#__PURE__*/_createElementVNode("div", {
    class: "ant-col ant-col-xs-24 ant-col-xl-3",
    style: {"text-align":"right"}
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Custo")
  ]),
  /*#__PURE__*/_createElementVNode("div", {
    class: "ant-col ant-col-xs-24 ant-col-xl-3",
    style: {"text-align":"right"}
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Total")
  ]),
  /*#__PURE__*/_createElementVNode("div", {
    class: "ant-col ant-col-xs-24 ant-col-xl-4",
    style: {"text-align":"center"}
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Estoque")
  ]),
  /*#__PURE__*/_createElementVNode("div", {
    class: "ant-col ant-col-xs-24 ant-col-xl-2",
    style: {"text-align":"center"}
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Ações")
  ])
], -1)
const _hoisted_3 = { class: "ant-col ant-col-xs-4 ant-col-4" }
const _hoisted_4 = { class: "ant-col ant-col-xs-2 ant-col-2" }
const _hoisted_5 = { class: "ant-col ant-col-xs-3 ant-col-3" }
const _hoisted_6 = { class: "ant-col ant-col-xs-3 ant-col-3" }
const _hoisted_7 = { class: "ant-col ant-col-xs-3 ant-col-3" }
const _hoisted_8 = { class: "ant-col ant-col-xs-3 ant-col-3" }
const _hoisted_9 = { class: "ant-col ant-col-xs-4 ant-col-4" }
const _hoisted_10 = {
  class: "ant-col ant-col-xs-2 ant-col-2",
  style: {"text-align":"center"}
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = {
  key: 2,
  class: "ant-row ss-grade-personalizada-titulo",
  style: {"margin-top":"8px"}
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", {
  class: "ant-col ant-col-xs-24 ant-col-xl-4",
  style: {"text-align":"left","font-weight":"bold"}
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Total")
], -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-2" }, null, -1)
const _hoisted_16 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-3",
  style: {"text-align":"right","font-weight":"bold"}
}
const _hoisted_17 = { class: "ss-titulo-campo" }
const _hoisted_18 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-3",
  style: {"text-align":"right","font-weight":"bold"}
}
const _hoisted_19 = { class: "ss-titulo-campo" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_selecionar_produto = _resolveComponent("selecionar-produto")!
  const _component_selecionar_unidade_produto_movimento = _resolveComponent("selecionar-unidade-produto-movimento")!
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_selecionar_estoque = _resolveComponent("selecionar-estoque")!
  const _component_icone = _resolveComponent("icone")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_card = _resolveComponent("card")!
  const _component_preview_pdf = _resolveComponent("preview-pdf")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(_component_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_a_form, { layout: "vertical" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_a_button, {
                  type: "primary",
                  size: "small",
                  onClick: _ctx.adicionarProdutoAcabadoPadrao,
                  disabled: !_ctx.props.editavel
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Adicionar Produto Acabado ")
                  ]),
                  _: 1
                }, 8, ["onClick", "disabled"])
              ]),
              _hoisted_2,
              (!_ctx.UtilitarioGeral.validaLista(_ctx.computedProdutoAcabado))
                ? (_openBlock(), _createBlock(_component_mensagem_sem_dados, {
                    key: 0,
                    mensagem: "Nenhum Produto Acabado Informado!"
                  }))
                : (_openBlock(), _createBlock(_component_a_form, {
                    key: 1,
                    name: "ss-form-produto-fornecedores",
                    class: "ss-altura-rolagem-padrao ss-desabilitar-rolagem-horizontal"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.computedProdutoAcabado, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "ant-row ss-grade-personalizada-linha",
                          key: index
                        }, [
                          _createElementVNode("div", _hoisted_3, [
                            _createVNode(_component_selecionar_produto, {
                              codigoSelecionado: item.codigoProduto,
                              "onUpdate:codigoSelecionado": ($event: any) => ((item.codigoProduto) = $event),
                              descricaoSelecionado: item.descricao,
                              "onUpdate:descricaoSelecionado": ($event: any) => ((item.descricao) = $event),
                              empresas: _ctx.props.empresas,
                              modoDefinicaoProduto: true,
                              apresentarCodigoInterno: true,
                              onChange: ($event: any) => (_ctx.limparUnidade(index)),
                              disabled: !_ctx.props.editavel,
                              tipoPCP: true,
                              style: {"text-align":"left"}
                            }, null, 8, ["codigoSelecionado", "onUpdate:codigoSelecionado", "descricaoSelecionado", "onUpdate:descricaoSelecionado", "empresas", "onChange", "disabled"])
                          ]),
                          _createElementVNode("div", _hoisted_4, [
                            _createVNode(_component_selecionar_unidade_produto_movimento, {
                              codigoProdutoDefinicao: item.codigoProduto,
                              codigoUnidadeSelecionada: item.codigoUnidade,
                              "onUpdate:codigoUnidadeSelecionada": ($event: any) => ((item.codigoUnidade) = $event),
                              empresas: _ctx.props.empresas,
                              sigla: item.siglaUnidade,
                              "onUpdate:sigla": ($event: any) => ((item.siglaUnidade) = $event),
                              apresentarApenasSigla: true,
                              casasDecimais: item.casasDecimais,
                              "onUpdate:casasDecimais": ($event: any) => ((item.casasDecimais) = $event),
                              disabled: !_ctx.props.editavel,
                              style: {"text-align":"center"}
                            }, null, 8, ["codigoProdutoDefinicao", "codigoUnidadeSelecionada", "onUpdate:codigoUnidadeSelecionada", "empresas", "sigla", "onUpdate:sigla", "casasDecimais", "onUpdate:casasDecimais", "disabled"])
                          ]),
                          _createElementVNode("div", _hoisted_5, [
                            _createVNode(_component_campo_numerico, {
                              valor: item.quantidade,
                              "onUpdate:valor": ($event: any) => ((item.quantidade) = $event),
                              "quantidade-casas-decimais": item.casasDecimais,
                              disabled: !_ctx.props.editavel,
                              onBlur: ($event: any) => (_ctx.calculaCustoTotal(index))
                            }, null, 8, ["valor", "onUpdate:valor", "quantidade-casas-decimais", "disabled", "onBlur"])
                          ]),
                          _createElementVNode("div", _hoisted_6, [
                            _createVNode(_component_campo_numerico, {
                              valor: item.peso,
                              "onUpdate:valor": ($event: any) => ((item.peso) = $event),
                              "quantidade-casas-decimais": item.casasDecimais,
                              disabled: !_ctx.props.editavel,
                              onBlur: ($event: any) => (_ctx.handlePesoChange(index))
                            }, null, 8, ["valor", "onUpdate:valor", "quantidade-casas-decimais", "disabled", "onBlur"])
                          ]),
                          _createElementVNode("div", _hoisted_7, [
                            _createVNode(_component_campo_numerico, {
                              valor: item.custoUnitario,
                              "onUpdate:valor": ($event: any) => ((item.custoUnitario) = $event),
                              "quantidade-casas-decimais": _ctx.props.casasDecimaisCusto,
                              disabled: true,
                              style: {"text-align":"right"}
                            }, null, 8, ["valor", "onUpdate:valor", "quantidade-casas-decimais"])
                          ]),
                          _createElementVNode("div", _hoisted_8, [
                            _createVNode(_component_campo_numerico, {
                              valor: item.custoTotal,
                              "onUpdate:valor": ($event: any) => ((item.custoTotal) = $event),
                              "quantidade-casas-decimais": _ctx.props.casasDecimaisCusto,
                              disabled: true,
                              style: {"text-align":"right"}
                            }, null, 8, ["valor", "onUpdate:valor", "quantidade-casas-decimais"])
                          ]),
                          _createElementVNode("div", _hoisted_9, [
                            _createVNode(_component_selecionar_estoque, {
                              empresas: _ctx.props.empresas,
                              tiposEstoques: [1, 3],
                              codigoSelecionado: item.codigoEstoque,
                              "onUpdate:codigoSelecionado": ($event: any) => ((item.codigoEstoque) = $event),
                              onChange: ($event: any) => (_ctx.salvarApontamento(index)),
                              disabled: !_ctx.props.editavel,
                              style: {"padding-left":"5px"}
                            }, null, 8, ["empresas", "codigoSelecionado", "onUpdate:codigoSelecionado", "onChange", "disabled"])
                          ]),
                          _createElementVNode("div", _hoisted_10, [
                            (item.quantidade > 0)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  onClick: ($event: any) => (_ctx.imprimirEtiqueta(item)),
                                  style: {"margin-right":"8px"}
                                }, [
                                  _createVNode(_component_icone, { nome: "imprimir" })
                                ], 8, _hoisted_11))
                              : _createCommentVNode("", true),
                            (_ctx.props.editavel)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 1,
                                  onClick: ($event: any) => (_ctx.validarExclusao(index))
                                }, [
                                  _createVNode(_component_icone, { nome: "excluir" })
                                ], 8, _hoisted_12))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      }), 128))
                    ]),
                    _: 1
                  })),
              (_ctx.UtilitarioGeral.validaLista(_ctx.computedProdutoAcabado))
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _hoisted_14,
                    _hoisted_15,
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.totalQuantidade.toFixed(4)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.totalPeso.toFixed(4)), 1)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_preview_pdf, {
      arquivos: _ctx.state.arquivosPdf
    }, null, 8, ["arquivos"])
  ], 64))
}